import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Layout from '@/components/Layout';
import LoaderActions from '@/store/ducks/loader';
import ReposActions from '@/store/ducks/repos';
import SkillsActions from '@/store/ducks/skills';
import ExperienceActions from '@/store/ducks/experience';
import AcademicActions from '@/store/ducks/academic';

const mapStateToProps = (state) => {
  const { repos } = state.reposReducer;
  const { skills } = state.skillsReducer;
  const { experienceData } = state.experienceReducer;
  const { academicDetails } = state.academicReducer;
  return {
    repos,
    skills,
    experienceData,
    academicDetails,
  };
};

const mapDispatchToProps = (dispatch) => {
  const { startLoaderRequest } = LoaderActions;
  const { getReposRequest } = ReposActions;
  const { getSkillsRequest } = SkillsActions;
  const { getExperienceRequest } = ExperienceActions;
  const { getAcademicRequest } = AcademicActions;
  return bindActionCreators({ getReposRequest, getSkillsRequest, startLoaderRequest, getAcademicRequest, getExperienceRequest }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
